import { yup } from '@guiker/yup-util'

export const password = yup.string().trim().min(8).required()
